// @codekit-prepend "src/chosen.jquery.min.js";
const counterUp = window.counterUp.default;

$(document).ready(function() {

	if($('#player').length) {
		const player = new Plyr('#player');
		player.muted = true;

		player.on('ended', function(e) {
			player.restart();
			player.stop();
			$('.video-popup').removeClass('show');
		});

		$('.video-popup').click(function() {
			$(this).removeClass('show');
			player.restart();
			player.stop();
		});

		$('.hero__video').click(function(e) {
			e.preventDefault();
			$('.video-popup').addClass('show');

			player.restart();
			player.stop();

			setTimeout(() => {
				player.play();
				player.muted = false;
			}, 100);
		});
	}

	$('a[href*="#"]').not('.post-feed__post').click(function(e) {
		e.preventDefault();

		if(window.innerWidth >= 1024) {
			const href = $(this).attr('href').replace('#', '');
			const trigger = scrollTriggers.find((trigger) => trigger.vars.id === href);

			if(href == 'overview') {
				$('html, body').animate({
						scrollTop: 0
					},1200);

			} else if(trigger) {
				let scrollTo = trigger.start;


				if(trigger.vars.id === 'projects-feed' || trigger.vars.id === 'contact-form' || trigger.vars.id === 'expanding-text') {
					scrollTo = trigger.start - $(`#${href}`).outerHeight(true) + window.innerHeight - $('header').outerHeight(true);
				}

				$('html, body').animate({
						scrollTop: scrollTo
					},1200);
			}
		} else {
			$('html, body').animate(
				{
					scrollTop: $($.attr(this, 'href')).offset().top - $('header').outerHeight()
				},
				1200
			);
			return false;
		}
	});

	$('.header__logo').click(() => {
		$('html, body').animate(
			{
				scrollTop: 0
			},
			1200
		);

	});

	$('.header__burger,.nav__list a').click(function() {
		$('header,nav,.header__burger').toggleClass('active');
	})

	if(window.innerWidth >= 1024) {
		$('.hero__video').mousemove(function(e) {
			$('.hero__cursor').css({
				left: e.pageX,
				top: e.pageY
			});
		});

		$('.hero__video').mouseenter(function() {
			$('.hero__cursor').addClass('active');
		});
		$('.hero__video').mouseleave(function() {
			$('.hero__cursor').removeClass('active');
		});

		// NON-DRY repeat of the code above...

		let timeout = null;
		$('.video-popup').mousemove(function(e) {
			const offset = $(this).offset();
			const x = e.pageX - offset.left;
			const y = e.pageY - offset.top;

			$('.video-popup__cursor').addClass('active');
			$('.video-popup__cursor').css({
				left: x,
				top: y
			});

			if(timeout) {
				clearTimeout(timeout);
			}

			timeout = setTimeout(() => {
				$('.video-popup__cursor').removeClass('active');
			}, 1000);
		});

	} else {

		// * Mobile accordion
		$('.expanding-text__mobile-title').click(function() {
			if(!$(this).parent().hasClass('show')) {
				$('.expanding-text__mobile-item.show').removeClass('show');
				$('.expanding-text__mobile-content').css('max-height', 0);
				const contentHeight = $(this).next().find('.group').outerHeight(true);
				$(this).next().css('max-height', contentHeight);
				$('.expanding-text__mobile').addClass('expanded');
			} else {
				$(this).next().css('max-height', 0);
				$('.expanding-text__mobile').removeClass('expanded');
			}

			$(this).parent().toggleClass('show');
		});
	}


	const headerLogoTl = gsap.timeline({
		scrollTrigger: {
			trigger: 'body',
			start: 'top top',
			end: `top-=${$('header').outerHeight()} top`,
			endTrigger: 'main.scroller',
			scrub: true

		},
	});


	if(window.innerWidth < 1024) {
		$(window).scroll(function() {
			if($(window).scrollTop() > window.innerHeight - 100) {
				$('header,.hero').addClass('scrolled');
			} else {
				$('header,.hero').removeClass('scrolled');
			}
		})
	}

	if($('.projects-feed.no-filter').length) {

		$('.projects-feed__item-link,.project-popup__next a').click(function(e) {
			e.preventDefault();
			const postId = $(this).attr('href')
			const popup = $(`#${postId}`);
			const nextProject = $(this).parent().parent().next();

			let heading,img,href;
			if(nextProject.length && !nextProject.hasClass('close-cursor') && nextProject.hasClass('active')) {
				heading = nextProject.find('.projects-feed__item-title').text();
				img = nextProject.find('.projects-feed__item-image img').attr('src');
				href = nextProject.find('.projects-feed__item-link').attr('href')

			} else if(nextProject.hasClass('close-cursor') && $(`.projects-feed__item[data-id="${postId}"]`).next().hasClass('active')) {
				heading = $(`.projects-feed__item[data-id="${postId}"]`).next().find('.projects-feed__item-title').text();
				img = $(`.projects-feed__item[data-id="${postId}"]`).next().find('.projects-feed__item-image img').attr('src');
				href = $(`.projects-feed__item[data-id="${postId}"]`).next().find('.projects-feed__item-link').attr('href')
			} else {
				heading = $('.projects-feed__item-title').first().text();
				img = $('.projects-feed__item-image img').first().attr('src');
				href = $('.projects-feed__item-link').first().attr('href')
			}

			$('.project-popup__next .next-post').attr('href', href);
			$('.project-popup__next h3').text(heading);
			$('.project-popup__next img').attr('src', img);

			$('.project-popup__section').removeClass('active')
			$('.project-popup').addClass('active');
			popup.addClass('active');

			$('.project-popup').click(function(e) {
				if(!$(e.target).closest('.project-popup__container').length) {
					$('.project-popup').removeClass('active');
					$('.project-popup__section').removeClass('active');
				}
			});



			if(window.innerWidth >= 1024) {
				$('.project-popup').mousemove(function(e) {
					if($(e.target).hasClass('project-popup')) {
						const offset = $(this).offset();
						const x = e.pageX - offset.left;
						const y = e.pageY - offset.top;

						$('.project-popup__cursor').addClass('active');

						$('.project-popup__cursor').css({
							left: x,
							top: y
						});
					} else {
						$('.project-popup__cursor').removeClass('active');
					}
				});
			}

			$('.project-popup__container').scrollTop(0);
		});
	}


	if($('form.projects-feed__filter').length) {
		$(document).click(function(e) {
			if($('.projects-feed__filter-item.active').length) {
				if(!$(e.target).closest('.projects-feed__filter-item.active').length) {
					$('.projects-feed__filter-item.active').removeClass('active');
				}
			}
		});

		$('.projects-feed__filter-item').click(function(e) {
			if($(e.target).hasClass('projects-feed__filter-item')) {
				$(this).toggleClass('active');
			}
		});

		$('.dropdown-item').click(function() {
			const value = $(this).data('value');
			$('.dropdown-item.active').removeClass('active');
			$(this).addClass('active');
			$('.projects-feed__filter-item').removeClass('active');
			$(this).parent().parent().find('select').val(value).trigger('change');
		});

		$('form.projects-feed__filter select').bind('change', $.debounce(400, function() {
			const serializedData = $('form.projects-feed__filter').serialize();

			$.ajax({
				type: 'POST',
				url: novm_admin.ajax_url,
				data: {
					action: 'ajax_get_projects',
					form_data: serializedData
				},
				beforeSend: function() {
					$('.projects-feed__feed').addClass('fetching')
					$('.ajax-loader').fadeIn(200);
				},
				success: function(res) {
					const projects = JSON.parse(res);
					$('.ajax-loader').fadeOut(200);
					setTimeout(() => {
						$('.projects-feed__feed').html(projects.html);

						setTimeout(() => {
							$('.projects-feed__item.active').addClass('init');
						}, 300);

						updateProjectOffsets();
						updateProjectProgress();

						$('.projects-feed__item-link,.project-popup__next a').click(function(e) {
							e.preventDefault();
							const postId = $(this).attr('href')
							const popup = $(`#${postId}`);
							const nextProject = $(this).parent().parent().next();

							let heading,img,href;

							if(nextProject.length && !nextProject.hasClass('close-cursor')) {
								heading = nextProject.find('.projects-feed__item-title').text();
								img = nextProject.find('.projects-feed__item-image img').attr('src');
								href = nextProject.find('.projects-feed__item-link').attr('href')

							} else if(nextProject.hasClass('close-cursor') && $(`.projects-feed__item[data-id="${postId}"]`).next().length) {
								heading = $(`.projects-feed__item[data-id="${postId}"]`).next().find('.projects-feed__item-title').text();
								img = $(`.projects-feed__item[data-id="${postId}"]`).next().find('.projects-feed__item-image img').attr('src');
								href = $(`.projects-feed__item[data-id="${postId}"]`).next().find('.projects-feed__item-link').attr('href')
							} else {
								heading = $('.projects-feed__item-title').first().text();
								img = $('.projects-feed__item-image img').first().attr('src');
								href = $('.projects-feed__item-link').first().attr('href')
							}

							$('.project-popup__next .next-post').attr('href', href);
							$('.project-popup__next h3').text(heading);
							$('.project-popup__next img').attr('src', img);

							$('.project-popup__section').removeClass('active')
							$('.project-popup').addClass('active');
							popup.addClass('active');

							if(popup.hasClass('form-visibility-hidden')) {
								$('.project-popup__form').hide();
							} else {
								$('.project-popup__form').show();
							}

							$('.project-popup').click(function(e) {
								if(!$(e.target).closest('.project-popup__container').length) {
									$('.project-popup').removeClass('active');
									$('.project-popup__section').removeClass('active');
								}
							});



							if(window.innerWidth >= 1024) {
								$('.project-popup').mousemove(function(e) {
									if($(e.target).hasClass('project-popup')) {
										const offset = $(this).offset();
										const x = e.pageX - offset.left;
										const y = e.pageY - offset.top;

										$('.project-popup__cursor').addClass('active');

										$('.project-popup__cursor').css({
											left: x,
											top: y
										});
									} else {
										$('.project-popup__cursor').removeClass('active');
									}
								});
							}

							$('.project-popup__container').scrollTop(0);
						});


						$('.projects-feed__feed').removeClass('fetching');
					}, 300);
				},
				error: function(err){
					console.error(err);
			}
			})
		}));

		$('form.projects-feed__filter select').each(function() {
			$(this).change(function() {
				let offset = window.innerWidth >= 1024 ? 20 : 10;
				const selectedText = $(this).children("option:selected").text();

				$(this).css('width', `${(offset + selectedText.length * 10)}px`);
			}).trigger('change');
		})
	}

	const sections = gsap.utils.toArray('.scroller .pane');

	if(sections.length > 1) {
		ScrollTrigger.matchMedia({
			"(min-width: 1024px)": function() {

				sections.forEach((section, i) => {
					const id = section.id;
					gsap.to(section, {
						scrollTrigger: {
							id: id,
							trigger: section,
							start: 'bottom bottom',
							endTrigger: 'html',
							pinSpacing: false,
							end: 'bottom bottom',
							pin: true,
							scrub: true,
						},
						y: 0,
						opacity: 1,
						duration: 1
					});
				});

 				headerLogoTl.to('.header__logo', {
					top: parseInt($('header').css('padding-top')) + 10,
					duration: 1
				}).to('.header__logo img', {
					height: 32,
					duration: 1,
					onComplete: function() {
						$('.header__logo').addClass('locked');
					},
					onReverseComplete: function() {
						$('.header__logo').removeClass('locked');
					}
				},0).to('.hero__subheading', {
					opacity: 0,
					duration: 0.15,
				},0);

				$(window).scroll(function() {
					if($(window).scrollTop() + $(window).height() > $(document).height() - 100 && $('.scroller .pane').last().find('section').hasClass('contact-form')) {
						$('.scroller .pane').last().find('section').addClass('bg');
					} else {
						$('.scroller .pane').last().find('section').removeClass('bg');
					}

				})
			}

		});

	}

	let entered = false;

	gsap.to('.projects-feed', {
		scrollTrigger: {
			trigger: '.projects-feed',
			start: `top bottom-=${$('header').outerHeight()}`,
			end: 'top top',
			onEnter: () => {
				if(!entered) {
					entered = true;
					$('.projects-feed').find('h2.projects-feed__stat-value span').each(function() {
						let duration = 3500;

						if($(this)[0].innerText.length <= 3) {
							duration = 1500;
						}

						counterUp($(this)[0], {
							delay: 20,
							duration: duration,
						} )
					})
				}
			}
		},
	});

	if($('.projects-feed__load-more').length) {
		const offset = window.innerWidth >= 1024 ? 140 : 30;
		ScrollTrigger.create({
			trigger: '.projects-feed__load-more',
			start: `bottom bottom-=${offset}px`,
			end: `bottom bottom-=${offset}px`,
			onEnter: () => {
				if($('.projects-feed__load-more').css('display') !== 'none') {
					$('.projects-feed__load-more .btn').click();
				}
			}
		})
	}

	if($('.scroll-top').length) {
		$('.scroll-top').click(function() {
			$('html, body').animate({
				scrollTop: 0
			}, 500);
		})
	}

	// gsap.to('.about', {
	// 	scrollTrigger: {
	// 		id: 'about',
	// 		trigger: '.about',
	// 		start: 'bottom bottom',
	// 		endTrigger: 'html',
	// 		pinSpacing: false,
	// 		end: 'bottom bottom',
	// 		pin: true,
	// 		scrub: true,
	// 	},
	// 	y: 0,
	// 	opacity: 1,
	// 	duration: 1
	// });


	// gsap.to('.approach', {
	// 	scrollTrigger: {
	// 		id: 'approach',
	// 		trigger: '.approach',
	// 		start: 'bottom bottom',
	// 		endTrigger: 'html',
	// 		pinSpacing: false,
	// 		end: 'bottom bottom',
	// 		pin: true,
	// 		scrub: true,
	// 	},
	// 	y: 0,
	// 	opacity: 1,
	// 	duration: 1
	// });


	// gsap.to('.projects-feed', {
	// 	scrollTrigger: {
	// 		id: 'projects-feed',
	// 		trigger: '.projects-feed',
	// 		start: 'bottom bottom',
	// 		endTrigger: 'html',
	// 		pinSpacing: false,
	// 		end: 'bottom bottom',
	// 		pin: true,
	// 		scrub: true,
	// 	},
	// 	y: 0,
	// 	opacity: 1,
	// 	duration: 1
	// });

	// gsap.to('.blog-feed', {
	// 	scrollTrigger: {
	// 		id: 'blog-feed',
	// 		trigger: '.blog-feed',
	// 		start: 'bottom bottom',
	// 		endTrigger: 'html',
	// 		pinSpacing: false,
	// 		end: 'bottom bottom',
	// 		pin: true,
	// 		scrub: true,
	// 	},
	// 	y: 0,
	// 	opacity: 1,
	// 	duration: 1
	// });

	if($('.post-feed').length) {
		$('.post-feed__filter select').each(function() {
			$(this).change(function() {
				const selectedText = $(this).children("option:selected").text();

				$(this).css('width', `${(20 + selectedText.length * 10)}px`);
			}).trigger('change');
		})
	}

	$('.expanding-text__accordion-title').click(function() {
		const index = $(this).data('index');

		$('.expanding-text__accordion-title').removeClass('active');
		$(this).addClass('active');

		$('.expanding-text__accordion-text,.expanding-text__accordion-image').removeClass('active');
		$(`.expanding-text__accordion-text[data-index="${index}"],.expanding-text__accordion-image[data-index="${index}"]`).addClass('active');
	});


	// $('.projects-feed__item.small').each(function() {
	// 	const projectBelow = $(this).next().next();
	// 	let offset = 145;

	// 	if(projectBelow.length) {
	// 		offset = ($(this).outerHeight(true) - $(this).find('.projects-feed__item-group').outerHeight(true) - 100)  * -1;
	// 	}

	// 	$(projectBelow).css('margin-top', `${offset}px`);
	// });

	// set the max height of .projects-feed__feed to the 4th project's offset bottom + 120px



	if($('.projects-feed').length) {
		$('.projects-feed__load-more img,.projects-feed__load-more .btn').click(function() {
			const nextBatch = $('.projects-feed__item:not(.active)').slice(0, 4);

			nextBatch.addClass('active');

			setTimeout(function() {
				nextBatch.addClass('visible');
				// nextBatch.css('opacity', 1);
			},200);

			updateProjectProgress();
			// updateProjectOffsets();
			ScrollTrigger.refresh();


			if($('.projects-feed__item:not(.active)').length === 0) {
				$('.projects-feed__load-more').hide();
			}
		});

	}

	if($('.swiper.blog-feed__slider').length) {
		const swiper = new Swiper('.swiper.blog-feed__slider', {
			slidesPerView: 1.1,
			slidesPerColumn: 1,
			allowTouchMove: false,
			spaceBetween: 7,
			breakpoints: {
				1024: {
					slidesPerView: 3,
					slidesPerColumn: 3,
					spaceBetween: 10
				}
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
		});


		$(window).resize(function() {
			let largestHeight = 0;

			$('.blog-feed__slide-text').each(function() {
				if($(this).outerHeight() > largestHeight) {
					largestHeight = $(this).outerHeight();
				}
			})

			$('.blog-feed__slide-text').css('min-height', largestHeight);

			if($('.blog-feed__arrows').length && window.innerWidth >= 1200) {
				$('.blog-feed__arrows').css('margin-top', largestHeight);
			}

		}).resize();
	}



	$(window).resize(function() {
		if($('.expanding-text').outerHeight() < $('.about').outerHeight() && window.innerWidth >= 1024) {
			$('.expanding-text').css('min-height', $('.about').outerHeight() - 40);
		}

		if(window.innerWidth >= 1200) {
			$('.blog-feed__group').css('height', $('.blog-feed__slide-image img').outerHeight());
		}

	}).resize();

	let formName = '';

	$(document).bind('gform_post_render', function(event, formId, currentPage){
		$('#input_2_8').chosen();
		$('#gform_next_button_2_7').click(function() {
			formName = $('#input_2_1').val();
		});

		if($('#field_2_14').length) {
			$('#field_2_14 p span').text(formName);
		}

		$('#input_2_8').change(function() {
			$('.chosen-container.chosen-container-single').removeClass('chosen-container-active');
		});

		$('.gfield--type-fileupload input').attr('value', 'Upload File');
	});

	$(document).on('lity:ready', function(event, instance) {
		if ($('.lity').find('.blog-popup').length) {
			$('.lity').addClass('lity-blog');

		} else if($('.lity').find('#video-popup').length) {
			$('.lity').addClass('lity-video');
		}
	});


	$('.blog-feed__slide a,a[href="#privacy-policy"], a[href="#terms-and-conditions"], a[href="#disclaimer"], .staff-feed__staff-person, .featured-staff__staff-person,.blog-popup__content-next_post a').click(function(e) {
		e.preventDefault();

		const postId = $(this).attr('href').replace('#', ''); // due to inconsistencies in the href values..
		const popup = $(`#${postId}`);

		$('.blog-popup,.content-popup,.staff-popup').removeClass('active');
		popup.addClass('active');

		$('.blog-popup,.content-popup,.staff-popup').click(function(e) {
			if(!$(e.target).closest('.blog-popup__section,.content-popup__section,.staff-popup__section').length) {
				$('.blog-popup,.content-popup,.staff-popup').removeClass('active');
			}
		});


		if(window.innerWidth >= 1024) {
			$('.blog-popup,.content-popup,.staff-popup').mousemove(function(e) {
				if($(e.target).hasClass('blog-popup') || $(e.target).hasClass('content-popup') || $(e.target).hasClass('staff-popup')) {
					const offset = $(this).offset();
					const x = e.pageX - offset.left;
					const y = e.pageY - offset.top;

					$('.blog-popup__cursor,.content-popup__cursor,.staff-popup__cursor').addClass('active');

					$('.blog-popup__cursor,.content-popup__cursor,.staff-popup__cursor').css({
						left: x,
						top: y
					});
				} else {
					$('.blog-popup__cursor,.content-popup__cursor,.staff-popup__cursor').removeClass('active');
				}
			});
		}
	});


	if($('.featured-staff__staff.swiper').length) {
		const swiper = new Swiper('.featured-staff__staff.swiper', {
			slidesPerView: 1.1,
			slidesPerColumn: 1,
			spaceBetween: 7,
			allowTouchMove: true,
			breakpoints: {
				768: {
					slidesPerView: 2.1,
					slidesPerColumn: 2,
					spaceBetween: 10,
					allowTouchMove: true,
				},
				1024: {
					slidesPerView: 3,
					slidesPerColumn: 3,
					spaceBetween: 10
				}
			},
		});
	}

	// ! don't have time to improve this sorry.
	window.almComplete = function(alm){
		$('.post-feed__post').click(function(e) {
			e.preventDefault();

			const postId = $(this).attr('href').replace('#', ''); // due to inconsistencies in the href values..
			const popup = $(`#${postId}`);

			$('.blog-popup').removeClass('active');
			popup.addClass('active');

			$('.blog-popup').click(function(e) {
				if(!$(e.target).closest('.blog-popup__section').length) {
					$('.blog-popup').removeClass('active');
				}
			});

			if(window.innerWidth >= 1024) {
				$('.blog-popup').mousemove(function(e) {
					if($(e.target).hasClass('blog-popup') || $(e.target).hasClass('content-popup')) {
						const offset = $(this).offset();
						const x = e.pageX - offset.left;
						const y = e.pageY - offset.top;

						$('.blog-popup__cursor').addClass('active');

						$('.blog-popup__cursor').css({
							left: x,
							top: y
						});
					} else {
						$('.blog-popup__cursor').removeClass('active');
					}
				});
			}
		});

		$(window).resize(function() {
			if(window.innerWidth >= 768) {
				let largestHeight = 0;

				$('.post-feed__post-title').each(function() {
					if($(this).outerHeight() > largestHeight) {
						largestHeight = $(this).outerHeight();
					}
				})

				$('.post-feed__post-title').css('min-height', largestHeight);
			}
		}).resize();

		$('.alm-reveal .post-feed__post').each(function() {
			const ID = $(this).attr('href');

			let nextPost = $(`.alm-reveal .post-feed__post[href="${ID}"]`).next('.post-feed__post');

			let heading, image, link;

			if(nextPost.length) {
				heading = nextPost.find('.post-feed__post-title').text();
				image = nextPost.find('.post-feed__post-image img').attr('src');
				link = nextPost.attr('href');
			} else {
				nextPost = $('.alm-reveal .post-feed__post').first();
				heading = nextPost.find('.post-feed__post-title').text();
				image = nextPost.find('.post-feed__post-image img').attr('src');
				link = nextPost.attr('href');
			}

			if(image) {
				$(`${ID} .blog-popup__content-next_post`).find('img').attr('src', image).show();
			} else {
				$(`${ID} .blog-popup__content-next_post`).find('img').hide();
			}
			$(`${ID} .blog-popup__content-next_post`).find('h3').text(heading);
			$(`${ID} .blog-popup__content-next_post a`).attr('href', link);
		})
	};

	if($('.project-popup__content-carousel.swiper').length) {

		$('.project-popup__content-carousel.swiper').each(function() {
			const slider = $(this);

			const swiper = new Swiper(slider[0], {
				loop: true,
				navigation: {
					prevEl: slider.find('.swiper-button-prev')[0],
					nextEl: slider.find('.swiper-button-next')[0],
				},
			});

			swiper.on('slideChange', function() {
				const current = swiper.realIndex + 1;
				slider.find('.count .current').text(current);

				$('.project-popup__content-captions span').hide();
				$(`.project-popup__content-captions span:nth-child(${current})`).show();
			});
		})
	}


	/////////////////////////////////////////////////////////////////////////
	//// CSS variable setter
	webHeight();

	updateProjectProgress();
	if(window.innerWidth >= 1024) {
		updateProjectOffsets();

		window.addEventListener('resize', webHeight);
		window.addEventListener('resize', updateProjectOffsets);
		window.addEventListener('resize', updateProjectProgress);
	}

	const scrollTriggers = ScrollTrigger.getAll();
	const sectionWaypoints = [];

	scrollTriggers.forEach((trigger) => {
		if(trigger.trigger) {
			let heightOffset = trigger.trigger.clientHeight;

			// if(trigger.trigger.classList.contains('projects-feed')) {
			// 	heightOffset = trigger.trigger.style.maxHeight.replace('px', '');
			// }

			const start = trigger.start - heightOffset + 100;
			const end = start + heightOffset;

			sectionWaypoints.push({
				id: trigger.trigger.id,
				start,
				end,
			});
		}
	});

	$(window).scroll(function() {
		const scrollPos = $(document).scrollTop();

		const activeTrigger = sectionWaypoints.find(trigger => {
			return scrollPos >= trigger.start && scrollPos <= trigger.end;
		});

		if(scrollPos < 200) {
			$('.header a[href*="#"]').removeClass('active')
			$('.header a[href*="#"]:first-child').addClass('active');

		} else if(scrollPos + $(window).height() >= $(document).height() - 100) {
			$('.header a[href*="#"]').removeClass('active')
			$('.header a[href*="#"]:last-child').addClass('active');

		} else if(activeTrigger) {
			$('.header a[href*="#"]')
				.removeClass('active')
				.filter(`[href="#${activeTrigger.id}"]`)
				.addClass('active');
		}



	}).scroll();

});



function updateProjectOffsets() {
	$('.projects-feed__item').each(function(index) {
		const side = index % 2 === 0 ? 'left' : 'right';

		$(this).addClass(side);
		const contentHeight = $(this).find('.projects-feed__item-group').outerHeight(true);
		const itemHeight = $(this).outerHeight(false);
		const itemPaddingBottom = parseInt($(this).css('padding-bottom'));
		const gap = itemHeight - itemPaddingBottom - contentHeight;
		let offset = 0;


		if(gap > 50) {
			const projectBelow = $(this).next().next();
			if(projectBelow.length) {
				offset = -Math.abs(gap);
				$(projectBelow).css('margin-top', `${offset}px`);
			}
		}


	});
}

// * Safari height issues for iPad and iPhones
function webHeight() {
	const doc = document.documentElement;
	const headerHeight = $('header').outerHeight(true);
	doc.style.setProperty('--header-height', `${headerHeight}px`);
	doc.style.setProperty('--vp-height', `${window.innerHeight}px`);
}

function setCookie(name,value,days) {
	var expires = "";
	if (days) {
			var date = new Date();
			date.setTime(date.getTime() + (days*24*60*60*1000));
			expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');
	for(var i=0;i < ca.length;i++) {
			var c = ca[i];
			while (c.charAt(0)==' ') c = c.substring(1,c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
	}
	return null;
}
function eraseCookie(name) {
	document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}



function updateProjectProgress() {
	if($('.projects-feed__item.active').length < $('.projects-feed__item').length) {
		const projectTop = $('.projects-feed__feed').offset().top;
		const projectBottom = $('.projects-feed__item.active').last().offset().top + $('.projects-feed__item.active').last().outerHeight(true);

		$('.projects-feed__feed').css('max-height', `${projectBottom - projectTop}px`);

		$('.projects-feed__load-more').show();
	} else {
		$('.projects-feed__feed').css('max-height', '100%');
		$('.projects-feed__load-more').hide();
	}
	ScrollTrigger.refresh();
}